/**
 * VERSIONE LIBRERIA 3
 */

/**
 * RenderRange
 *
 **/
var RenderRange = Render.extend({
    type : 'range',
    classData : 'range',
    classTemplate : 'range',
    domainValuesOrder : null,
    domainValues: {},
    operator : null,
    control_selector_start : '[data-render_control_start]',
    control_selector_end : '[data-render_control_end]',
    render_start : '[data-render_start]',
    render_end : '[data-render_end]',

    _setData : function (jQe) {
        var self = this;
        self._setSelectValues(jQe.find(self.render_start),self.value);
        self._setSelectValues(jQe.find(self.render_end),self.end_value);
    },

    _setSelectValues : function(container,value) {
        //ORDINAMENTO DELLE OPTIONS
        var self = this;
        var el = container;
        console.log(container,value);
        var vs = [];
        if (self.domainValuesOrder) {
            vs = self.domainValuesOrder;
        } else {
            vs = _.sortBy(_.keys(self.domainValues), function (num) {
                return num;
            });
        }
        var el =
        el.html('');
        for (var i = 0; i < vs.length; i++) {
            //for (var v in self.data.domainValues) {
            var v = vs[i];

            //console.log('OPTIONS: ',v);
            var selected = false;
            if (v == value) {
                selected = true;
            }
            var opt = $('<option>').attr({
                value : v
            });
            if (selected)
                opt.attr('selected','selected');
            opt.html(self.domainValues[v]);
            el.append(opt);
        }
        el.attr("value", value);
    },
    _renderSearch : function (jQe) {
        var self = this;
        self._setData(jQe);
        var el = jQe.find(self.control_selector_start);
        el.attr("name", 's_' + self.key + '[]').attr('value',self.value);

        var el = jQe.find(self.control_selector_end);
        el.attr("name", 's_' + self.end_key + '[]').attr('value',self.end_value);

        $('<input>').attr({
            type: 'hidden',
            name: 's_' + self.key + "_operator",
            'data-control_operator' : self.key,
            value : self.operator
        }).appendTo(jQe);
    },
    _renderEdit : function (jQe) {
        var self = this;
        self._setData(jQe);
        var el = jQe.find(self.control_selector_start);
        var name = self.key;
        var exists = self.key.indexOf('[]') > 0?self.key.slice(0,-2)+'_exists[]':self.key+'_exists';
        el.attr("name", name).attr('value',self.value);

        var el = jQe.find(self.control_selector_end);
        var name = self.end_key;
        var exists = self.end_key.indexOf('[]') > 0?self.end_key.slice(0,-2)+'_exists[]':self.end_key+'_exists';
        el.attr("name", name).attr('value',self.end_value);

        // // creazione campo nascosto per checkare la presenza del campo
        // $('<input>').attr({
        //     type: 'hidden',
        //     name: exists,
        //     value : 1
        // }).appendTo(jQe);
    },
    _finalizeEdit : function(){
        var self = this;
        var jq_start = $(self.container).find(self.control_selector_start);
        var jq_end = $(self.container).find(self.control_selector_end);

        $(self.container).find(self.render_start).change(function() {
            jq_start.val($(this).val());
            var value = {
                start : jq_start.val(),
                end : jq_end.val()
            }
            self._emitEvent('change',value);
        });
        $(self.container).find(self.render_end).change(function() {
            jq_end.val($(this).val());
            var value = {
                start : jq_start.val(),
                end : jq_end.val()
            }
            self._emitEvent('change',value);
        });
    },
    _finalizeSearch : function(){
        var self = this;
        self._finalizeEdit();
    },
    _finalizeView : function(){},

    setDomainValues : function (values,valuesOrder) {
        var self = this;
        self.domainValues = values;
        if (valuesOrder) {
            self.domainValuesOrder = valuesOrder;
        } else {
            self.domainValuesOrder = null;
        }
        self._setData(self.container);
    },
    setValue : function(value) {
        var self = this;
        if ('start' in value)
            $(self.container).find(self.render_start).val(value.start).change();
        if ('end' in value)
            $(self.container).find(self.render_end).val(value.end).change();
    }
});